import { render, staticRenderFns } from "./QuestionFooter.vue?vue&type=template&id=6d54dffe&scoped=true"
import script from "./QuestionFooter.vue?vue&type=script&lang=js"
export * from "./QuestionFooter.vue?vue&type=script&lang=js"
import style0 from "./QuestionFooter.vue?vue&type=style&index=0&id=6d54dffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d54dffe",
  null
  
)

export default component.exports